import api, { paginado } from './apiClient'

/** `GET /roles` — catálogo de roles, somente leitura (escrita fica no SSO). */
export const getAllRoles = async () => {
  const response = await api.get('/roles')
  return { data: paginado(response) }
}

/**
 * As roles do usuário logado chegam em `GET /auth/me` e são resolvidas pelo
 * AuthContext. Não existe rota de roles por usuário no contrato.
 */
export const getListUserRoles = async () => {
  throw new Error('Roles por usuário vêm de /auth/me; não há rota dedicada no contrato da API.')
}

/** Vínculo de role a usuário é escrita, e escrita de role vive só no SSO. */
export const addRoleService = async () => {
  throw new Error('Atribuição de role não existe no contrato da API. Use o painel do SSO.')
}

export const removeRoleService = addRoleService
